// @ts-ignore
/* eslint-disable */
import request from '../../utils/request';

/** 查询优惠券 # **获取AccessToken** 
<a href='http://auth-service-beta2.shrise.cn/doc.html#/default/token-controller/generateUserAccessTokenUsingPOST' target='_blank'>点击此处获取测试站用户AccessToken</a>参数示例: 
  ```
{
  "productType": 171,
  "userId": 240
}
  ```
 GET /coupons/plan/number/${param0} */
export async function couponsPlanNumberPlanNumberUsingGET(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.couponsPlanNumberPlanNumberUsingGETParams,
  options?: { [key: string]: any },
) {
  const { planNumber: param0, ...queryParams } = params;
  return request<API.BaseResultCouponPlanResp>(`/coupons/plan/number/${param0}`, {
    method: 'GET',
    params: { ...queryParams },
    ...(options || {}),
  });
}
